/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AvailableReceiptExportDTO } from '../dto';
// @ts-ignore
import { ValidationErrorResponseDTO } from '../dto';
/**
 * ReceiptExportApi - axios parameter creator
 * @export
 */
export const ReceiptExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get all available receipt-exports
         * @param {boolean} [includeAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableReceiptExports: async (includeAll?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/receiptExports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeAll !== undefined) {
                localVarQueryParameter['includeAll'] = includeAll;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReceiptExportApi - functional programming interface
 * @export
 */
export const ReceiptExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReceiptExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get all available receipt-exports
         * @param {boolean} [includeAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableReceiptExports(includeAll?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AvailableReceiptExportDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableReceiptExports(includeAll, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReceiptExportApi - factory interface
 * @export
 */
export const ReceiptExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReceiptExportApiFp(configuration)
    return {
        /**
         * 
         * @summary get all available receipt-exports
         * @param {boolean} [includeAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableReceiptExports(includeAll?: boolean, options?: any): AxiosPromise<Array<AvailableReceiptExportDTO>> {
            return localVarFp.getAvailableReceiptExports(includeAll, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAvailableReceiptExports operation in ReceiptExportApi.
 * @export
 * @interface ReceiptExportApiGetAvailableReceiptExportsRequest
 */
export interface ReceiptExportApiGetAvailableReceiptExportsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ReceiptExportApiGetAvailableReceiptExports
     */
    readonly includeAll?: boolean
}

/**
 * ReceiptExportApi - object-oriented interface
 * @export
 * @class ReceiptExportApi
 * @extends {BaseAPI}
 */
export class ReceiptExportApi extends BaseAPI {
    /**
     * 
     * @summary get all available receipt-exports
     * @param {ReceiptExportApiGetAvailableReceiptExportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReceiptExportApi
     */
    public getAvailableReceiptExports(requestParameters: ReceiptExportApiGetAvailableReceiptExportsRequest = {}, options?: AxiosRequestConfig) {
        return ReceiptExportApiFp(this.configuration).getAvailableReceiptExports(requestParameters.includeAll, options).then((request) => request(this.axios, this.basePath));
    }
}
